export default {
  simpleIndex: 'Index',
  index: ' Shop Index',
  jescard: ' Brand Index',
  top: 'Top Clicks Index',
};
